export default {
    computed: {
        listBannerState() {
            const mode = this.bannerMode
            const searchTerm = this.bannerSearchTerm || ''
            const itemLabel = this.bannerItemLabel
            const show = ['latest', 'searched', 'expired'].includes(mode)

            switch (mode) {
                case 'latest':
                    return {
                        show,
                        variant: 'success',
                        text: `Showing latest 25 ${itemLabel}`,
                    }
                case 'searched':
                    return {
                        show,
                        variant: 'primary',
                        text: searchTerm
                            ? `Showing search results for "${searchTerm}"`
                            : 'Showing search results',
                    }
                case 'expired':
                    return {
                        show,
                        variant: 'warning',
                        text: `Showing expired ${itemLabel}`,
                    }
                default:
                    return {
                        show: false,
                        variant: 'light',
                        text: '',
                    }
            }
        },
        showListBanner() {
            return this.listBannerState.show
        },
        listBannerVariant() {
            return this.listBannerState.variant
        },
        listBannerText() {
            return this.listBannerState.text
        },
    },
}
